import { resolveFeatureFlag } from './shared/features'

const dev = process.env.NODE_ENV === 'development'
const stripWrappingQuotes = (value: string) =>
  value.replace(/^(['"])(.*)\1$/, '$2')

const readEnv = (name: string, fallback: string) => {
  const value = process.env[name]
  return typeof value === 'string' && value.trim() !== ''
    ? stripWrappingQuotes(value.trim())
    : fallback
}

const getRuntimeOrigin = () => {
  if (typeof window === 'undefined') return ''
  return window.location.origin || ''
}

const runtimeOrigin = getRuntimeOrigin()
const runtimeImageServer = runtimeOrigin ? `${runtimeOrigin}/image` : '/image'

const config = {

  dev,

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /*                               API-Server                              */
  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

  // Der API-Server
  api_server: !dev 
    ? readEnv('REACT_APP_API_SERVER', runtimeOrigin)
    : 'http://localhost:51002'
  ,

  // Image-Server
  image_server: !dev
    ? readEnv('REACT_APP_IMAGE_SERVER', runtimeImageServer)
    : 'http://shops-image:50002'
  ,

  // Price-Spy-Server
    price_spy: !dev
    ? readEnv('REACT_APP_PRICE_SPY', runtimeOrigin)
    : 'http://shops-price-spy:51003',

  backend_title: readEnv('REACT_APP_BACKEND_TITLE', 'Shop Backend'),
  backend_base_url: readEnv('REACT_APP_BACKEND_BASE_URL', runtimeOrigin),

  features: {
    priceSpy: resolveFeatureFlag('priceSpy', process.env.REACT_APP_FEATURE_PRICE_SPY),
    productImports: resolveFeatureFlag('productImports', process.env.REACT_APP_FEATURE_PRODUCT_IMPORTS),
  },
  
  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

}

export default config
